define.alias("ember-svg-jar/helpers/svg-jar", "preview-grid/helpers/svg-jar");